import {StorageUtils} from "xmgoing-utils";


enum SinglePageAppMap {
  "xm-print-des" = "VITE_APP_PRINT_DES",
  'xm-help-center' = 'VITE_APP_HELP_CENTER',
}

function getSinglePageAppDevPort(name: string) {
  return import.meta.env[`${name}_PORT`]
}


function getSinglePageAppUrl(name: keyof typeof SinglePageAppMap) {
  const Url = new URL(location.origin)
  const env = import.meta.env

  const appName = SinglePageAppMap[name];
  const target = env[appName]

  const specialList = [
    "xm-print-des",
    'xm-report-des',
  ]

  const port = getSinglePageAppDevPort(appName);

  if (specialList.includes(name)) {
    Url.pathname = target
    if (import.meta.env.DEV && port) {
      Url.port = port
    }
  } else {
    if (import.meta.env.PROD) {
      if (/^[0-9]+$/.test(target)) {
        Url.port = target
      } else {
        Url.pathname = target
      }
    } else {
      Url.port = target
    }
  }

  const url = Url.toString();
  return url
}


const SysConfigUtils = {
  xmPrintPage: (() => {
    let runUrl=`${location.protocol}://${window.location.hostname}:${
      import.meta.env.VITE_APP_VUE_PRINT
    }`;
    //可能存在配置重复： 所以特殊处理一下
    runUrl=runUrl.replace("::",":");
    if (import.meta.env.PROD) {
      runUrl = location.origin
    }
    return runUrl;
  })(),
  //设置系统配置信息
  initPageJumpUrl(sysConfigJson) {
    //如果是开发态 则不需要执行
    if (import.meta.env.DEV) {
      return;
    }
    for (const propName in this) {
      if (sysConfigJson[propName] && sysConfigJson[propName].length > 0) {
        const Url = new URL(location.origin)

        if (sysConfigJson[propName].indexOf(":") > 0) {
          Url.port = ''
        }

        this[propName] = sysConfigJson[propName].replace(
          "${baseUrl}",
          Url.toString()
        );
      }
    }
  },
  //打印设计器
  printDesUrl: (() => getSinglePageAppUrl("xm-print-des"))(),
  autoFlowUrl: (() => {
    if(import.meta.env.PROD){
      return new URL('/xm-auto-flow', location.origin).toString()
    }else{
      return  'http://localhost:30088/xm-auto-flow/';
    }
  })(),
  proMainDesUrl: (() => {
    let runUrl = import.meta.env.VITE_GLOB_PRO_MAIN_DES
    //可能存在配置重复： 所以特殊处理一下
    runUrl = runUrl.replace("::", ":");
    if (import.meta.env.PROD) {
      runUrl = location.origin + "/xm-pro-main-des-single"
    }
    return runUrl;
  })(),
  // 运行环境登录地址
  xmErp: (() => {
    let runUrl = `http://${window.location.hostname}:${
      import.meta.env.VITE_APP_VUE_XM_ERP
    }`;
    //可能存在配置重复： 所以特殊处理一下
    runUrl = runUrl.replace("::", ":");
    if (import.meta.env.PROD) {
      runUrl = location.origin
    }
    return runUrl;
  })(),
  // 运行环境登录地址
  devClientUrl: (() => {
    const {
      origin
    } = location

    const Url = new URL(origin)
    if (import.meta.env.DEV) {
      Url.port = import.meta.env.VITE_APP_DEV_CLIENT.replaceAll(':', '')
    } else {
      Url.port = import.meta.env.VITE_APP_DEV_CLIENT.replaceAll(':', '')
    }
    console.log(Url.port)
    return Url.toString()
  })(),
  defLayout: "go-left-sub-menu-layout", // 缺省展示的布局
  // 静态资源的地址
  staticUrl: (() => {
    return location.origin;
  })(),
  //打开设计地址
  mainPageDesUrl: (() => {
    if (location.host.indexOf("localhost") >= 0) {
      return `http://localhost:10088/main-des/`;
    } else {
      const Url = new URL('/main-des/', location.origin)

      const port = Number(Url.port)

      if (port) {
        Url.port = `${port + 1}`
      }

      return Url.toString()
    }
  })(),
  //打开设计地址
  commonPageDesUrl: (() => {
    if (location.host.indexOf("localhost") >= 0) {
      return `http://localhost:33499/xm-vue-des/`;
    } else {
      const Url = new URL('/xm-vue-des/', location.origin)

      const port = Number(Url.port)

      if (port) {
        Url.port = `${port + 1}`
      }

      return Url.toString()
    }
  })(),
  getAppRunningLoginUrl: (outSystemPortal) => {
    const {
      origin,
      port: currentPort,
      hostname,
    } = location

    const Url = new URL(origin)
    const isIpOrLocalhost = hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname);

    // 正式域名访问：登录页统一走同域名，不附加 30026 等业务端口
    if (!isIpOrLocalhost) {
      Url.port = '';
      return Url.toString();
    }

    // 以下仅 localhost / IP 开发场景
    if (!currentPort) {
      Url.port = '';
      return Url.toString();
    }

    Url.port = import.meta.env.VITE_APP_VUE_PREVIEW.replaceAll(':', '');
    //如果是生产环境才需要执行
    if (!import.meta.env.DEV) {
      const outSystemPortalCache = StorageUtils.getItem('outSystemPortal');
      if (/^\d+/.test(outSystemPortalCache)) {
        Url.port = outSystemPortalCache;
      }
      if (/^\d+/.test(outSystemPortal)) {
        Url.port = outSystemPortal;
      }
    }
    if(!import.meta.env.DEV&&(outSystemPortal==='80'||outSystemPortal==='8080'||outSystemPortal==='443')){
      Url.port="";
    }
    return Url.toString()
  },
  // 模板中心预览地址
  templatePreviewUrl: (() => {
    return location.origin;
  })(),
  //帮助文档
  docCenterUrl: (() => {
    return getSinglePageAppUrl('xm-help-center');
  })(),
  // 后台请求地址
  go_eplat_adress: (() => {
    return location.origin;
  })(),
}
window.SysConfigUtils = SysConfigUtils;
export default SysConfigUtils;
